$(document).ready(function () {
    initializeGeolocationAvailability(function () {
        navigator.geolocation.getCurrentPosition(function (position) {
            $('.js-geo-collection').each(function () {
                let collectionPlaceholder = $(this);
                const locationParam = position.coords.latitude + ',' + position.coords.longitude;

                $.ajax({
                    type: "GET",
                    url: `/Home/${collectionPlaceholder.data('collection')}?geoLatLong=${locationParam}`,
                    success: function (result) {
                        collectionPlaceholder.replaceWith(result);
                    }
                });
            })
        });
    })
});